import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { GroupChildVisibility, GroupChildVisibilityDTO } from "./groupChildVisibility";
import { QuestionType } from "../types/questionType";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface GroupChildVisibilityWithQuestionDetailsDTO {
  groupChildVisibility: GroupChildVisibilityDTO;
  questionType: QuestionType.QuestionTypeDTO;
  question?: SurveyLocalizedTextDTO | null;
}

export class GroupChildVisibilityWithQuestionDetails {
  readonly isGroupChildVisibilityWithQuestionDetailsGroupChildVisibilityWithQuestionDetails: boolean = true;

  readonly groupChildVisibility: GroupChildVisibility;
  readonly questionType: QuestionType.QuestionType;
  readonly question: SurveyLocalizedText | null;


  constructor(
  groupChildVisibility: GroupChildVisibility, 
  questionType: QuestionType.QuestionType, 
  question: SurveyLocalizedText | null = null
  ) {
    this.groupChildVisibility = groupChildVisibility;
    this.questionType = questionType;
    this.question = question;
  }

  static fromDTO(dto: GroupChildVisibilityWithQuestionDetailsDTO): GroupChildVisibilityWithQuestionDetails {
    const groupChildVisibility = GroupChildVisibility.fromDTO(getObject(dto, "groupChildVisibility", InvalidGroupChildVisibilityWithQuestionDetailsGroupChildVisibilityError));
    const questionType = QuestionType.fromDTO(getObject(dto, "questionType", InvalidGroupChildVisibilityWithQuestionDetailsQuestionTypeError));
    let question = getOptionalObject(dto, "question");
    if(question !== undefined && question !== null) {
      question = SurveyLocalizedText.fromDTO(getObject(dto, "question", InvalidGroupChildVisibilityWithQuestionDetailsQuestionError));
    }
    return new GroupChildVisibilityWithQuestionDetails(
      groupChildVisibility,
      questionType,
      question
    );
  }

  toDTO(): GroupChildVisibilityWithQuestionDetailsDTO {
    const dto: GroupChildVisibilityWithQuestionDetailsDTO = {
        groupChildVisibility: this.groupChildVisibility.toDTO(),
        questionType: QuestionType.toDTO(this.questionType),
    };
    if (this.question !== undefined && this.question !== null){
      dto.question = this.question.toDTO();
    }
    return dto;
  }
  }

GroupChildVisibilityWithQuestionDetails.prototype.toString = function toString(): string {
  return `GroupChildVisibilityWithQuestionDetails(groupChildVisibility='${this.groupChildVisibility}',questionType='${this.questionType}',question='${this.question}')`;
};

export class InvalidGroupChildVisibilityWithQuestionDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityWithQuestionDetailsError";
  }
}
export class InvalidGroupChildVisibilityWithQuestionDetailsGroupChildVisibilityError extends InvalidGroupChildVisibilityWithQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityWithQuestionDetailsGroupChildVisibilityError";
  }
}

export class InvalidGroupChildVisibilityWithQuestionDetailsQuestionTypeError extends InvalidGroupChildVisibilityWithQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityWithQuestionDetailsQuestionTypeError";
  }
}

export class InvalidGroupChildVisibilityWithQuestionDetailsQuestionError extends InvalidGroupChildVisibilityWithQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityWithQuestionDetailsQuestionError";
  }
}
